import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
// Modules
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgApexchartsModule } from 'ng-apexcharts';

// Components
import { LogoComponent } from './components/logo/logo.component';
import { PrimaryButtonComponent } from './components/buttons/primary-button/primary-button.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { OfferDetailModalComponent } from './components/modals/offer-detail-modal/offer-detail-modal.component';
import { RouterModule } from '@angular/router';
import { CreditScoreChartComponent } from './components/charts/credit-score-chart/credit-score-chart.component';
import { CreditHistoryChartComponent } from './components/charts/credit-history-chart/credit-history-chart.component';
import { NoDataComponent } from './components/no-data/no-data.component';
import { NotificationBarComponent } from './components/notification-bar/notification-bar.component';
import { ESignModalComponent } from './components/modals/e-sign-modal/e-sign-modal.component';
import { FormsModule } from '@angular/forms';








@NgModule({
  declarations: [
    LogoComponent,
    FooterComponent,
    SidebarComponent,
    PrimaryButtonComponent,
    OfferDetailModalComponent,
    ESignModalComponent,
    CreditScoreChartComponent,
    CreditHistoryChartComponent,
    NoDataComponent,
    NotificationBarComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    NgApexchartsModule,
    FormsModule
  ],
  exports: [
    LogoComponent,
    FooterComponent,
    SidebarComponent,
    PrimaryButtonComponent,
    OfferDetailModalComponent,
    ESignModalComponent,
    CreditScoreChartComponent,
    NgApexchartsModule,
    CreditHistoryChartComponent,
    NoDataComponent,
    NotificationBarComponent,
    RouterModule
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
